<template>
  <div>
    <div
      class="title is-6 has-text-centered mb-3"
      v-html="
        $t(
          'lets take a picture of your ids front, press the button when youre ready'
        )
      "
    ></div>
    <div
      style="position: relative; width: 100%; max-width: 400px; margin: 0 auto"
    >
      <video
        ref="video"
        autoplay
        playsinline
        style="
          width: 100%;
          max-width: 400px;
          border-radius: 8px;
          background: #000;
          display: block;
        "
        @loadedmetadata="updateOverlaySize"
        @resize="updateOverlaySize"
      ></video>
      <!-- Overlay opaco con rectángulo transparente, SOLO sobre el video -->
      <div
        style="
          pointer-events: none;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 2;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <svg
          :width="videoWidth"
          :height="videoHeight"
          :viewBox="'0 0 ' + videoWidth + ' ' + videoHeight"
          style="display: block"
        >
          <defs>
            <mask id="mask-rect">
              <rect :width="videoWidth" :height="videoHeight" fill="white" />
              <rect
                :x="videoWidth * 0.08"
                :y="videoHeight * 0.25"
                :width="videoWidth * 0.84"
                :height="videoHeight * 0.5"
                rx="16"
                fill="black"
              />
            </mask>
          </defs>
          <rect
            :width="videoWidth"
            :height="videoHeight"
            fill="rgba(20,22,26,0.85)"
            :mask="'url(#mask-rect)'"
          />
          <rect
            :x="videoWidth * 0.08"
            :y="videoHeight * 0.25"
            :width="videoWidth * 0.84"
            :height="videoHeight * 0.5"
            rx="16"
            fill="none"
            stroke="#00d1b2"
            stroke-width="4"
          />
          <text
            :x="videoWidth / 2"
            :y="videoHeight / 2"
            text-anchor="middle"
            fill="#00d1b2"
            font-size="25"
            font-weight="bold"
            dy="7"
            style="user-select: none; opacity: 0.5"
          >
            {{ $t("place your id here here") }}
          </text>
        </svg>
      </div>
    </div>
    <div
      class="button is-primary is-rounded is-fullwidth mt-5"
      @click="take_picture"
      style="z-index: 5"
    >
      <span class="icon">
        <i class="fa fa-camera"></i>
      </span>
      <span>{{ $t("take picture") }}</span>
    </div>
    <div class="notification is-info mt-5">
      <div class="message-body">
        <ul>
          <li>
            {{ $t("make sure the document stands out from the background") }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { post } from "@/utils";

export default {
  name: "Face",
  components: {},
  data() {
    return {
      retrived_verification_data: null,
      videoWidth: 320,
      videoHeight: 240,
    };
  },
  methods: {
    async startCamera() {
      try {
        this.stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "environment" },
          audio: false,
        });
        this.$refs.video.srcObject = this.stream;
        this.$refs.video.onloadedmetadata = this.updateOverlaySize;
      } catch (e) {
        this.error = "No se pudo acceder a la cámara: " + e.message;
      }
    },
    take_picture() {
      let v = this;
      const video = v.$refs.video;
      if (!video.srcObject) {
        v.$emit("error", v.$t("camera not started"));
        return;
      }

      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      // Convert the image to a data URL
      const dataURL = canvas.toDataURL("image/jpeg", 1);

      v.$root.loader(true);
      post("/identity/perform/id-front", {
        uuid: v.$route.params.uuid,
        image: dataURL,
      })
        .then((response) => {
          if (v.stream) {
            v.stream.getTracks().forEach((track) => track.stop());
          }
          v.$emit("success");
        })
        .catch((error) => {
          v.$emit("error", error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    start() {
      this.startCamera();
    },
    updateOverlaySize() {
      if (this.$refs.video) {
        this.videoWidth = this.$refs.video.videoWidth || 320;
        this.videoHeight = this.$refs.video.videoHeight || 240;
      }
    },
  },
  mounted() {
    // this.startCamera();
  },
  beforeDestroy() {
    if (this.stream) {
      this.stream.getTracks().forEach((track) => track.stop());
    }
  },
};
</script>

<style scoped></style>
